import React from 'react';
import { Container, Col, Row, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet'; // Importing Helmet for SEO
import MaritalTherapyImg from '../img/Carousel4.jpg'; // Image for Marital Therapy

const Marital_Therapy = () => {
    const cardData = [
        {
            id: 1,
            title: 'Communication Enhancement',
            text: 'One of the main goals of marital therapy is to improve communication between partners. Miscommunication is often a root cause of conflict in relationships. Through therapy, couples learn effective communication skills, such as active listening, non-verbal cues, and expressing feelings constructively, helping them address issues calmly and thoughtfully.',
        },
        {
            id: 2,
            title: 'Conflict Resolution Skills',
            text: 'Marital therapy provides tools for resolving conflicts in a healthy way. It helps partners understand each other’s perspectives, find common ground, and agree on solutions. Therapists teach strategies like compromise, negotiation, and setting healthy boundaries to reduce arguments and create a more harmonious relationship.',
        },
        {
            id: 3,
            title: 'Emotional Intimacy',
            text: 'Emotional intimacy refers to the deep emotional connection that couples share. In therapy, partners work on fostering trust and understanding. By opening up to each other and expressing their emotional needs, couples can rebuild intimacy and strengthen their bond, leading to greater emotional satisfaction in the relationship.',
        },
        {
            id: 4,
            title: 'Addressing Infidelity',
            text: 'When infidelity occurs, marital therapy can help partners address the emotional pain, rebuild trust, and understand the underlying issues that led to the betrayal. Through therapy, couples can work through the trauma of infidelity, set boundaries, and determine if they are ready to rebuild or part ways.',
        },
        {
            id: 5,
            title: 'Parenting and Family Dynamics',
            text: 'For couples with children, marital therapy can provide support in navigating the challenges of parenting and family dynamics. Therapy helps couples align on parenting approaches, resolve disagreements about family roles, and improve teamwork as parents. This can also improve the overall family environment and reduce stress within the household.',
        },
        {
            id: 6,
            title: 'Building a Stronger Foundation',
            text: 'Marital therapy focuses not only on resolving current issues but also on building a stronger relationship foundation for the future. It helps couples understand each other’s values, goals, and priorities, fostering a deeper connection and enhancing the long-term stability of the relationship.',
        },
    ];

    return (
        <div>
            <Helmet>
                <title>Marital Therapy | Improve Communication & Relationship Health</title>
                <meta name="description" content="Marital therapy helps couples enhance communication, resolve conflicts, and build stronger relationships. Learn how therapy can help with intimacy, infidelity, and parenting challenges." />
                <meta name="keywords" content="Marital Therapy, Relationship Counseling, Communication in Marriage, Infidelity Counseling, Conflict Resolution, Emotional Intimacy, Parenting Support" />
                <meta name="author" content="Your Company Name" />
                <meta property="og:title" content="Marital Therapy | Improve Communication & Relationship Health" />
                <meta property="og:description" content="Enhance your relationship with marital therapy. Explore communication skills, conflict resolution, and intimacy building to create a healthier, stronger partnership." />
                <meta property="og:image" content={MaritalTherapyImg} />
                <meta property="og:url" content="https://yourwebsite.com/marital-therapy" />
            </Helmet>

            <Container>
                <Row>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <img src={MaritalTherapyImg} alt="Marital Therapy" className='img-fluid h-100 w-100 rounded-md '/>
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <h1 style={{fontFamily:'monospace'}} className='mb-4'>Marital Therapy</h1>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>Marital therapy is a form of counseling aimed at improving the relationship between married couples or partners. The goal of marital therapy is to address issues within the relationship, enhance communication, and strengthen emotional and physical intimacy. Whether you're dealing with communication problems, trust issues, or a major life transition, marital therapy offers a structured space for couples to explore their concerns and work toward resolution.</p>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>Therapy helps couples explore the root causes of conflict, learn how to manage emotions, and develop healthier relationship patterns, ultimately leading to a more fulfilling partnership.</p>
                    </Col>
                </Row>
            </Container>

            <Container className='mb-5'>
                <Row>
                    {cardData.map((card) => (
                        <Col xs={12} sm={6} md={6} lg={6} className="g-4" key={card.id}>
                            <Card className='bg-info-subtle'>
                                <Card.Body>
                                    <Card.Title style={{color:'#093c60'}} className='fw-bold'>{card.title}</Card.Title>
                                    <Card.Text>{card.text}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default Marital_Therapy;
